import { render } from "./WQlook.vue?vue&type=template&id=e85cfb16&scoped=true"
import script from "./WQlook.vue?vue&type=script&lang=js"
export * from "./WQlook.vue?vue&type=script&lang=js"

import "./WQlook.vue?vue&type=style&index=0&id=e85cfb16&lang=scss&scoped=true"
import "./WQlook.vue?vue&type=style&index=1&id=e85cfb16&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e85cfb16"]])

export default __exports__